import { render, staticRenderFns } from "./PowerBiReport.vue?vue&type=template&id=6bb6e262&scoped=true&"
import script from "./PowerBiReport.vue?vue&type=script&lang=js&"
export * from "./PowerBiReport.vue?vue&type=script&lang=js&"
import style0 from "./PowerBiReport.vue?vue&type=style&index=0&id=6bb6e262&lang=scss&scoped=true&"
import style1 from "./PowerBiReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6e262",
  null
  
)

export default component.exports